// extracted by mini-css-extract-plugin
export default {"card":"page_card__RTihE","title":"page_title__aqMAm","controls":"page_controls__4tVM0","control":"page_control__KWW5V"};